module.exports = __webpack_public_path__ + "img/onestop.347ceec1.png";